import type { RouteRecordRaw } from 'vue-router'

import { routeNames } from './route-names'
import { basicRouteMap } from './router-modules.ts'

import { uriRoles } from '@/router/uri-roles.ts'
import contractIcon from '@/assets/icons/sidebar/contract.svg'
import taskIcon from '@/assets/icons/sidebar/todo-list.svg'
import projectIcon from '@/assets/icons/sidebar/project.svg'
import contractorIcon from '@/assets/icons/sidebar/contractor.svg'
import configIcon from '@/assets/icons/sidebar/config.svg'
import dashboardIcon from '@/assets/icons/sidebar/dashboard.svg'
import { ROOT_ROUTE_REDIRECT_PATH } from '@/router/constant.ts'
import { pmSelectedRouterList } from '@/views/pm/config.ts'
import { cmSelectedRouterList } from '@/views/cm/config.ts'
import { tmSelectedRouterList } from '@/views/tm/config.ts'
export default [
  {
    path: ROOT_ROUTE_REDIRECT_PATH,
    name: routeNames.Welcome,
    component: () => import('@/views/Welcome.vue'),
    meta: {
      hideInMenu: true,
      title: 'Chào mừng',
      page: 'welcome',
    },
  },
  {
    path: '/dashboard',
    name: routeNames.Dashboard,
    component: () => import('@/views/dashboard/index.vue'),
    meta: {
      title: 'Dashboard',
      icon: dashboardIcon,
    },
  },
  {
    path: '/dashboard/cost-estimate-detail/:id',
    name: routeNames.DashboardCostEstimateDetail,
    component: () => import('@/views/dashboard/cost-estimate-detail/index.vue'),
    meta: {
      title: 'Tổng hợp dự toán',
      hidden: true,
      hideInMenu: true,
    },
  },
  {
    path: '/dashboard/cash-flow-detail/:id',
    name: routeNames.DashboardCashFlowDetail,
    component: () => import('@/views/dashboard/cash-flow-detail/index.vue'),
    meta: {
      title: 'Kế hoạch dòng tiền',
      hidden: true,
      hideInMenu: true,
    },
  },
  {
    path: '/pm',
    name: routeNames.ProjectManagement,
    component: basicRouteMap.RouteView,
    redirect: '/pm/project',
    meta: {
      title: 'Thông tin dự án',
      icon: projectIcon,
      hideInMenu: false,
    },
    children: [
      {
        path: '/pm/project',
        name: routeNames.ProjectList,
        component: () => import('@/views/pm/ListView.vue'),
        meta: {
          title: 'Danh mục dự án',
          uriRole: uriRoles.ProjectList,
          subMenuItems: pmSelectedRouterList,
        },
        children: [
          {
            path: '/pm/project/create',
            name: routeNames.ProjectCreate,
            component: () => import('@/views/pm/detail/index.vue'),
            meta: {
              title: 'Tạo dự án mới',
              uriRole: uriRoles.ProjectCreate,
            },
          },
          {
            path: '/pm/project/:id',
            name: routeNames.ProjectDetail,
            component: () => import('@/views/pm/detail/index.vue'),
            meta: {
              title: 'Chi tiết dự án',
              uriRole: uriRoles.ProjectDetail,
            },
          },
          {
            path: '/pm/project/:id/edit',
            name: routeNames.ProjectEdit,
            component: () => import('@/views/pm/detail/index.vue'),
            meta: {
              title: 'Cập nhật dự án',
              uriRole: uriRoles.ProjectEdit,
            },
          },
        ],
      },
      {
        path: '/pm/report/project-financial-year-report',
        name: routeNames.ProjectAccountingYearReport,
        component: () => import('@/views/pm/report/financial-year-plan.vue'),
        meta: {
          title: 'Kế hoạch tài chính năm',
          uriRole: uriRoles.ProjectAccountingYearReport,
          subMenuItems: pmSelectedRouterList,
        },
      },
      {
        path: '/pm/aggregation-cycle',
        name: routeNames.ProjectAggregationCycle,
        component: () => import('@/views/pm/AggregationCycleView.vue'),
        meta: {
          title: 'Chu kỳ cảnh báo',
          uriRole: uriRoles.ProjectAggregationCycle,
          subMenuItems: pmSelectedRouterList,
        },
      },
      {
        path: '/pm/draft-project',
        name: routeNames.DraftProject,
        component: () => import('@/views/pm/DraftProjectView.vue'),
        meta: {
          title: 'Dự thảo kế hoạch đầu tư',
          uriRole: uriRoles.DraftProjectSearch,
          subMenuItems: pmSelectedRouterList,
        },
      },
      {
        path: '/pm/appraisal',
        name: routeNames.ProjectAppraisal,
        component: () => import('@/views/pm/AppraisalView.vue'),
        meta: {
          title: 'Thẩm định hồ sơ',
          uriRole: uriRoles.ProjectAppraisal,
          subMenuItems: pmSelectedRouterList,
        },
        children: [
          {
            path: '/pm/appraisal/create',
            name: routeNames.ProjectAppraisalCreate,
            component: () => import('@/views/pm/appraisal/detail/index.vue'),
            meta: {
              title: 'Tạo mới yêu cầu thẩm định hồ sơ',
              uriRole: uriRoles.ProjectAppraisalCreate,
            },
          },
          {
            path: '/pm/appraisal/:id',
            name: routeNames.ProjectAppraisalDetail,
            component: () => import('@/views/pm/appraisal/detail/index.vue'),
            meta: {
              title: 'Chi tiết yêu cầu thẩm định',
              uriRole: uriRoles.ProjectAppraisalDetail,
            },
          },
          {
            path: '/pm/appraisal/:id/edit',
            name: routeNames.ProjectAppraisalEdit,
            component: () => import('@/views/pm/appraisal/detail/index.vue'),
            meta: {
              title: 'Chi tiết yêu cầu thẩm định',
              uriRole: uriRoles.ProjectAppraisalEdit,
            },
          },
        ],
      },
    ],
  },
  {
    path: '/profile-management',
    name: routeNames.ProfileManagement,
    component: () => import('@/views/coming-soon.vue'),
    meta: {
      title: 'Quản lý hồ sơ',
      icon: contractIcon,
    },
  },
  {
    path: '/cm',
    name: routeNames.ContractorManagement,
    component: () => basicRouteMap.RouteView,
    redirect: '/cm/contractor',
    meta: {
      title: 'Quản lý nhà thầu',
      icon: contractorIcon,
      hideInMenu: false,
    },
    children: [
      {
        path: '/cm/contractor',
        name: routeNames.ContractorList,
        component: () => import('@/views/cm/contractor/index.vue'),
        meta: {
          title: 'Danh sách nhà thầu',
          uriRole: uriRoles.ContractorList,
          subMenuItems: cmSelectedRouterList,
        },
      },
    ],
  },
  {
    path: '/tm',
    name: routeNames.TaskManagement,
    redirect: '/tm/task/list',
    component: basicRouteMap.RouteView,
    meta: {
      title: 'Quản lý công việc',
      icon: taskIcon,
      hideInMenu: false,
    },
    children: [
      {
        path: '/tm/task/list',
        name: routeNames.TaskList,
        component: () => import('@/views/tm/task/list/index.vue'),
        meta: {
          title: 'Danh sách công việc',
          uriRole: uriRoles.TaskList,
          subMenuItems: tmSelectedRouterList,
        },
      },
      {
        path: '/tm/task/detail/:id',
        name: routeNames.TaskDetail,
        component: () => import('@/views/tm/task/detail/detail.vue'),
        meta: {
          title: 'Chi tiết công việc',
          uriRole: uriRoles.TaskDetail,
        },
      },
    ],
  },
  {
    path: '/settings',
    name: routeNames.Settings,
    component: () => basicRouteMap.RouteView,
    redirect: '/settings/index',
    meta: {
      title: 'Cấu hình quản lý',
      icon: configIcon,
      hideInMenu: false,
    },
    children: [
      {
        path: '/settings/index',
        name: routeNames.SettingsMenuList,
        component: () => import('@/views/settings/menu-list.vue'),
        meta: {
          title: 'Cấu hình quản lý',
          uriRole: uriRoles.SettingsMenuList,
        },
      },
      {
        path: '/settings/check-list',
        name: routeNames.SettingsCheckList,
        component: () => import('@/views/settings/checklist/checklist.vue'),
        meta: {
          title: 'Checklist tài liệu',
          uriRole: uriRoles.SettingsCheckList,
        },
      },
      {
        path: '/settings/check-list/detail',
        name: routeNames.SettingsCheckListDetail,
        component: () => import('@/views/settings/checklist/detail/detail.vue'),
        meta: {
          title: 'Chi tiết checklist tài liệu',
          uriRole: uriRoles.SettingsCheckListDetail,
        },
      },
      {
        path: '/settings/global-list-detail/project-type',
        name: routeNames.SettingsProjectType,
        component: () => import('@/views/settings/global-list-detail/project-type.vue'),
        meta: {
          title: 'Loại dự án',
          uriRole: uriRoles.ProjectType,
        },
      },
      {
        path: '/settings/global-list-detail/objective-type',
        name: routeNames.SettingsObjectiveType,
        component: () => import('@/views/settings/global-list-detail/objective-type.vue'),
        meta: {
          title: 'Loại mục tiêu',
          uriRole: uriRoles.ObjectiveType,
        },
      },
      {
        path: '/settings/global-list-detail/budget-type',
        name: routeNames.SettingsBudgetType,
        component: () => import('@/views/settings/global-list-detail/budget-type.vue'),
        meta: {
          title: 'Loại ngân sách',
          uriRole: uriRoles.BudgetType,
        },
      },
      {
        path: '/settings/global-list-detail/invest-type',
        name: routeNames.SettingsInvestType,
        component: () => import('@/views/settings/global-list-detail/invest-type.vue'),
        meta: {
          title: 'Hình thức đầu tư',
          uriRole: uriRoles.InvestType,
        },
      },
      {
        path: '/settings/global-list-detail/capital-type',
        name: routeNames.SettingsCapitalType,
        component: () => import('@/views/settings/global-list-detail/capital-type.vue'),
        meta: {
          title: 'Loại nguồn vốn',
          uriRole: uriRoles.CapitalType,
        },
      },
      {
        path: '/settings/global-list-detail/important',
        name: routeNames.SettingsImportant,
        component: () => import('@/views/settings/global-list-detail/important.vue'),
        meta: {
          title: 'Mức độ ưu tiên',
          uriRole: uriRoles.Important,
        },
      },
      {
        path: '/settings/global-list-detail/close-project',
        name: routeNames.SettingsCloseProject,
        component: () => import('@/views/settings/close-project/index.vue'),
        meta: {
          title: 'Người kết thúc dự án',
          uriRole: uriRoles.CloseProject,
        },
      },
      {
        path: '/settings/global-list-detail/contractor-type',
        name: routeNames.SettingsContractorType,
        component: () => import('@/views/settings/global-list-detail/contractor-type.vue'),
        meta: {
          title: 'Loại nhà thầu',
          uriRole: uriRoles.ContractorType,
        },
      },
      {
        path: '/settings/global-list-detail/legal-type',
        name: routeNames.SettingsLegalType,
        component: () => import('@/views/settings/global-list-detail/legal-type.vue'),
        meta: {
          title: 'Loại hình pháp lý',
          uriRole: uriRoles.LegalType,
        },
      },
      {
        path: '/settings/global-list-detail/task-state',
        name: routeNames.SettingsTaskState,
        component: () => import('@/views/settings/global-list-detail/task-state.vue'),
        meta: {
          title: 'Trạng thái công việc',
          uriRole: uriRoles.TaskState,
        },
      },
      {
        path: '/settings/global-list-detail/task-priority',
        name: routeNames.SettingsTaskPriority,
        component: () => import('@/views/settings/global-list-detail/task-priority.vue'),
        meta: {
          title: 'Mức độ ưu tiên',
          uriRole: uriRoles.TaskPriority,
        },
      },
      {
        path: '/settings/appraisal/list',
        name: routeNames.SettingAppraisalList,
        component: () => import('@/views/settings/appraisal/index.vue'),
        meta: {
          title: 'Người phê duyệt',
          // uriRole: uriRoles.AppraisalSetting
          uriRole: uriRoles.TaskPriority,
        },
      },
    ],
  },
] as RouteRecordRaw[]
